<template>
	<div class="productDetail">
		<!-- <base-offer-notifications /> !-->
		<base-bread-crumb :items="breadCrumbsItems"></base-bread-crumb>
		<div class="productDetailWrapper" v-if="productDetail && userProfile">
			<div class="productDetail__left">
				<img v-if="productDetail.images && productDetail.images.length > 1"  :src="productDetail.images[0].original"  width="50%" :alt="productDetail.title"/>
				<div v-html="productDetail.description"></div>
			</div>
			<div class="productDetail__right">
				<div class="productDetail__right--selectItems">
					<label class="bestSeller" v-if="productDetail.bestseller">best seller</label>
					<div class="productDetail__right--selectItems--subTitle">
						{{ 'PART NUMBER: ' + productDetail.upc }}
					</div>
					<div class="productDetail__right--selectItems--Title">
						{{ productDetail.title }}
					</div>
					<div class="productDetail__right--selectItems--price"
						v-if="productDetail.product_class == 'online-ai-service' && productDetail.cheapest_variant_price_availability">
						<money-format
							:value="Number(productDetail.cheapest_variant_price_availability.discounted_price)"
							:locale='`en`' :currency-code='userProfile.default_currency' :subunits-value=false
							:hide-subunits=false>
						</money-format>
						<span class="productItem__info--oldprice"
							v-if="productDetail.cheapest_variant_price_availability && productDetail.cheapest_variant_price_availability.is_discounted">
							<money-format
								:value="Number(productDetail.cheapest_variant_price_availability.price.excl_tax)"
								:locale='`en`' :currency-code='userProfile.default_currency' :subunits-value=false
								:hide-subunits=false>
							</money-format>
						</span>
					</div>
					<div class="productDetail__right--selectItems--price" v-else>
						<money-format :value="Number(productDetail.discounted_price)" :locale='`en`'
							:currency-code='userProfile.default_currency' :subunits-value=false :hide-subunits=false>
						</money-format>
						<span class="productItem__info--oldprice" v-if="productDetail.is_discounted">
							<money-format :value="Number(productDetail.price_availability.price.excl_tax)"
								:locale='`en`' :currency-code='userProfile.default_currency' :subunits-value=false
								:hide-subunits=false>
							</money-format>
						</span>
					</div>
					<p class="productDetail__right--selectItems--soldBy">
						{{ 'Sold by ' + productDetail.soldby }}
					</p>
					<div class="checkbox">
						<label v-for="(option) in productDetail.product_options" :key="option.name">
							<input type="checkbox" name="radio" />
							<span>
								<b>{{ option.name }}</b> {{ '(Cost = ' + option.price + ' )' }}
							</span>
						</label>
					</div>
					<!-- <div class="productDetail__right--selectItems--quantity">
						<label>Quantity</label>
						<base-touch-spin />
					</div> -->
					<!-- Add To Cart Button (No Children or Case Definitions) -->
					<button title="Add To Cart" class="btn btn-default full"
						v-if="!added && (!productDetail.case_definitions || productDetail.case_definitions.length == 0) && (!productDetail.children || productDetail.children.length == 0)"
						@click="addToMyCart()">
						<span class="icon big only-icon">
							<svg-icon icon-id="cart-icon" icon-viewbox="0 0 24 24"></svg-icon>
						</span>
						Add to Cart
					</button>
					<div class="inline-button" v-else>
						<!-- Add to Cart Icon Button-->
						<button title="Add To Cart" class="btn btn-default btn-small" v-if="!added"
							@click="addToMyCart()">
							<span class="icon big only-icon">
								<svg-icon icon-id="cart-icon" icon-viewbox="0 0 24 24"></svg-icon>
							</span>
						</button>
						<!-- Start Service for Digital Products -->
						<button title="Start Digital Service" class="btn btn-secondary full"
							@click.prevent="handleStartDigitalService"
							v-if="productDetail.product_class == 'digital-service' && productDetail.case_definitions.length > 0">
							Start This Service
						</button>
						<!-- Start Service for AI Products (Cephalo) -->
						<button title="Start Cephalo.Ai Service" class="btn btn-secondary full"
							@click.prevent="handleStartCepahloService"
							v-if="productDetail.product_class == 'online-ai-service'">
							Start This Service
						</button>
					</div>
					<!-- Added to My Cart Label-->
					<div class="mt-3" v-if="added">
						<label class="productDetail__right--addedToCart">
							<span class="icon">
								<svg-icon
									icon-id="checked"
									icon-viewbox="0 0 14 10"
								></svg-icon> </span
							>Added to Cart Successfully
						</label>
					</div>
				</div>
			</div>
		</div>
		<div class="productDetail__relatedProducts">
			<related-product-slider></related-product-slider>
		</div>
	</div>
</template>

<script>
// [*] Import UI Components
import BaseBreadCrumb from '@/common/components/base/BaseBreadCrumb.vue';
import BaseOfferNotifications from '@/common/components/base/BaseOfferNotifications.vue';
import BaseTouchSpin from '../common/components/base/BaseTouchSpin.vue';
import RelatedProductSlider from '@/components/productDetails/RelatedProductSlider.vue';
import MoneyFormat from 'vue-money-format';

// [*] Import BreadCrumb
import { productDetailBreadCrumbs } from "@/common/constant/breadCrumbs"

import { mapGetters } from 'vuex';
import { CatalogueHelper } from '@/common/crud-helpers/catalogue';
import { BasketHelper } from '@/common/crud-helpers/basket';

export default {
	props: {
		productId: String,
	},
	components: {
		MoneyFormat,
		BaseBreadCrumb,
		BaseOfferNotifications,
		BaseTouchSpin,
		RelatedProductSlider,
	},
	data() {
		return {
			breadCrumbsItems: [...productDetailBreadCrumbs],
			product: null,
		};
	},
	computed: {
		...mapGetters(['productDetail', 'userProfile', 'cartLines']),
		added: function() {
			if(this.cartLines.length === 0)
				return false
			if(this.product.product_class !== 'online-ai-service') {
				let index = this.cartLines.findIndex((item) => item.product_obj.id === this.product.id)
				return index === -1 ? false : true
			}
			else {
				let index = this.cartLines.findIndex((item) => item.product_obj.parent_id === this.product.id)
				return index === -1 ? false : true
			}
		},
	},
	watch: {
		productDetail() {
			this.product = this.productDetail
			this.breadCrumbsItems = [
				{
					text: 'Shop',
					href: '/shop/page=1',
				},
				{
					text: this.productDetail.categories[0],
					to: {
						name: 'Shop',
						params: { page: "1" },
						query: { filter: 'category', value: this.productDetail.categories[0]}
					}
				},
				{
					text: this.productDetail.title,
					active: true,
				}
			]
		}
	},
	mounted() {
		CatalogueHelper.getProductDetail({ id: this.productId })
	},
	methods: {
		addToMyCart() {
			if(!this.product) return;
			let url = this.product.children.length == 0 ? this.product.url : this.product.add_cart_url;
			let params = { "quantity": 1, "url": url }
			if (this.product.product_options.length > 0) params["options"] = this.product.product_options.map(item => ({ "option": item.url, "value": 0 }))
			BasketHelper.addCart(params)
		},
		handleStartDigitalService() {
			this.$router.push({
				name: 'start_digital_service',
				params: { lang: this.$i18n.locale, productId: String(this.productId), },
			})
		},
		handleStartCepahloService() {
			this.$router.push({
				name: 'Start New AI Service',
				params: {lang: this.$i18n.locale, productId: String(this.productId),  product: this.productDetail, }
			})
		},
	}
};
</script>

<style lang="scss">
.productDetail {
	.productDetailWrapper {
		display: flex;

		@media screen and (max-width: 991px) {
			flex-direction: column-reverse;
		}
	}

	&__left {
		display: flex;
		flex-direction: column;
		align-items: start;
		overflow: hidden;
		width: 70%;
		padding-right: 5%;
		transition: all 0.5s ease;

		@media screen and (max-width: 991px) {
			margin-right: rem(0px);
			margin-top: rem(50px);
		}

		h5 {
			margin-top: rem(25px);
			margin-bottom: rem(15px);
			line-height: 1.1;
		}

		p {
			font-size: rem(14px);

			&.bold-text {
				font-weight: 500;
			}

			span {
				color: var(--secondary);
			}
		}

		a {
			text-decoration: underline;
		}

		img {
			margin-bottom: rem(15px);

			@media screen and (max-width:991px) {
				text-align: center;
			}
		}
	}

	&__right {
		width: 30%;

		@media screen and (max-width: 991px) {
			flex: 0 0 100%;
			max-width: 100%;
		}

		&--selectItems {
			font-size: rem(14px);

			&--Title {
				color: var(--textPrimary);
				font-size: rem(24px);
				line-height: 1.4;
				margin-bottom: rem(25px);
			}

			&--subTitle {
				color: #8e8e8e;
				line-height: 1;
				margin: rem(14px) 0 rem(10px) 0;
			}

			&--price {
				color: var(--textPrimary);
				font-size: rem(28px);
				font-weight: 500;
				line-height: 1.1;
				margin-bottom: rem(10px);
				display: flex;
				align-items: center;

				span {
					color: #8e8e8e;
					font-size: rem(14px);
					margin-left: rem(10px);
					text-decoration: line-through;
					font-weight: 400;
				}
			}

			&--soldBy {
				font-style: italic;
				color: #8e8e8e;
				line-height: 1;
				margin-bottom: rem(10px);
			}

			&--quantity {
				margin: rem(18px) 0 rem(32px) 0;

				label {
					color: var(--default);
					font-size: rem(16px);
					margin-bottom: rem(10px);
				}

				.quantityToggle {
					width: 155px;
				}
			}

			.see-more {
				display: block;
				text-align: center;
				margin-top: rem(35px);
			}

			.inline-button {
				display: flex;
				margin-top: rem(22px);

				.btn {
					@media screen and (max-width: 1600px) {
						padding: rem(15px) rem(12px);
					}

					&:not(:last-child) {
						margin-right: rem(14px);

						@media screen and (max-width: 1350px) {
							margin-right: 6px;
						}
					}
				}
			}

			@media screen and (max-width:991px) {
				text-align: center;

				&--quantity {
					.quantityToggle {
						margin: auto;
					}

				}

				&--price {
					justify-content: center;
				}
			}

			@media screen and (max-width:991px) and (min-width:500px) {
				.button-row {
					.btn {
						width: 300px;
						margin: auto;
					}
				}
			}
		}

		&--addedToCart {
			color: #00966d;
		background: #edfdf3;
		border: 1px solid #a8eec4;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		padding: rem(19px) 0;
		padding-left: rem(17px);
		padding-right: rem(26px);
		height: 52px;
		font-size: rem(12px);
		font-weight: 500;
		border-radius: 8px;
		width: 100%;
		white-space: nowrap;
		.icon {
			margin-right: rem(13px);
			margin-top: rem(-6px);
		}
		svg {
			width: 14px;
			height: 10px;
		}
		}

		.checkbox {
			span {
				padding-bottom: 0;
				padding-left: rem(32px);

				&:after,
				&:before {
					top: 2px !important;
				}

				b {
					font-weight: 400;
					color: #22272e;
					font-size: rem(20px);
				}

				i {
					font-style: normal;
					font-size: rem(16px);
					font-weight: 500;
					color: var(--textPrimary);

					&.oldPrice {
						text-decoration: line-through;
						color: var(--textSecondary);
						font-weight: 400;
						margin-left: rem(8px);
					}
				}
			}
		}
	}

	&__relatedProducts {
		position: relative;
		padding-top: rem(20px);
	}
}
</style>
